/**
 * @description View view
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const viewBiz = new Logic()

viewBiz.findView = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.view.findView,
    data: data
  })
}

viewBiz.saveView = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.view.saveView,
    data: data
  })
}

viewBiz.deleteView = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.view.deleteView,
    data: data
  })
}

viewBiz.findViewById = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.view.findViewById,
    data: data
  })
}

viewBiz.getSourceData = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.view.getSourceData,
    data: data
  })
}

viewBiz.getKpiField = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.view.getKpiField,
    data: data
  })
}

viewBiz.getAllKpiField = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.view.getKpiField,
    data: data,
    allData: true
  })
}

// @负责人: xiehan
// @创建时间: 2018-03-12
// @版本: v1.0.13
// @描述: 视图配置过滤数据属性
class DataHelper {
  filterObj = {};
  stackName = '';
  filterDataList = [];

  propertyCount = 0;
  propertyNum = 0;

  filterKpiData (obj) {
    // 固定 data 开头
    const res = {}
    if (obj && obj[0]) {
      for (const key in obj[0]) {
        res[`data.${key}`] = `data.${key}`
      }
    }
    return res
  }

  filterData (obj) {
    this.filterObj = {}
    this.propertyNum = Object.getOwnPropertyNames(obj).length - 1
    for (let i in obj) {
      this.stackName = ''
      this.objCount = 0
      this.getEachPropertyName(obj, i)
    }
    for (let i in this.filterObj) {
      if (!this.checkAvailable(obj, i)) {
        delete this.filterObj[i]
      }
    }
  }

  getEachPropertyName (obj, i) {
    this.propertyCount++
    this.filterObj[this.stackName + i] = this.stackName + i
    if (this.propertyCount === this.propertyNum) {
      this.stackName = this.resetStackName(this.stackName, i)
      this.propertyCount = this.propertyNum = 0
      for (let j in this.filterObj) {
        if (j.indexOf('.') !== -1) {
          j = j.split('.')[j.split('.').length - 1]
        }
        if (!this.checkAvailable(obj, j)) {
          if (obj[j] instanceof Object && !Array.isArray(obj[j])) {
            this.propertyNum = Object.getOwnPropertyNames(obj[j]).length - 1
            this.stackName = this.stackName + j + '.'
            for (let k in obj[j]) {
              this.getEachPropertyName(obj[j], k)
            }
          } else if (Array.isArray(obj[j]) && obj[j][0] instanceof Object) {
            this.propertyNum = Object.getOwnPropertyNames(obj[j][0]).length - 1
            this.stackName = this.stackName + j + '.'
            for (let k in obj[j][0]) {
              this.getEachPropertyName(obj[j][0], k)
            }
          }
        }
      }
    }
  }

  // 当stackName中有.时，当前对象赋值完毕重置stackName。
  resetStackName (name, i) {
    let str = name + i
    let splitArr = str.split('.')
    return str.substring(0, str.indexOf(splitArr[1]))
  }

  // 检查当前属性是否是可用数据(非空或者是可用的数字、字符串、布尔值)。
  checkAvailable (data, name) {
    const nameArr = name.split('.')
    let filterObj = data
    let isTrue = false
    nameArr.map((item, index) => {
      if (filterObj[item] instanceof Array) {
        filterObj = filterObj[item][0]
      } else if (filterObj[item] instanceof Object) {
        filterObj = filterObj[item]
      } else if ((typeof filterObj[item] === 'string' || typeof filterObj[item] === 'number' || typeof filterObj[item] === 'boolean')) {
        isTrue = true
      }
    })
    return isTrue
  }

  filterDataByName (data, name) {
    this.filterDataList = []
    try {
      const nameArr = name.split('.')
      let filterObj = data
      nameArr.map((item, index) => {
        if (filterObj[item] instanceof Array) {
          filterObj[item].map((_item) => {
            this.filterDataList.push(_item[nameArr[index + 1]])
          })
        } else if (filterObj[item] instanceof Object) {
          filterObj = filterObj[item]
        } else if ((typeof filterObj[item] === 'string' || typeof filterObj[item] === 'number' || typeof filterObj[item] === 'boolean')) {
          this.filterDataList.push(filterObj[item])
        }
      })
    } catch (e) {
      console.error('check data type')
    }
  }

  getFilterObj () {
    return this.filterObj
  }

  getFilterDataList () {
    return this.filterDataList
  }
}

// @负责人: zhijie.huang
// @创建时间: 2018-11-19
// @版本: v2.0.0
// @描述: 视图配置的页面逻辑
class ViewHelper {
  // 构造系列的Columns
  static getSeriesDataColumns = function (data, seriesName) {
    const columns = []
    data.map((item) => {
      columns.push(item[seriesName])
    })
    return columns
  }
  // 构造系列的数据
  static seriesDataHandle (data, xName, seriesName) {
    const res = []
    data.map((item) => {
      item[xName].map((x, i) => {
        if (res[i]) {
          res[i][xName] = x
        } else {
          res[i] = {}
          res[i][xName] = x
        }
      })
      item['value'].map((y, i) => {
        if (res[i]) {
          res[i][item[seriesName]] = y
        } else {
          res[i] = {}
          res[i][item[seriesName]] = y
        }
      })
    })
    return res
  }
  // 构造图表的数据
  static chartDataHandle ({name, data, x, y, isSeries}) {
    try {
      let _data = data
      // const name = this.formModel.name
      // console.info('drawChart', this.formModel)
      const labelMap = {}
      const xKey = x.field.match(/(\w+\.)+(\w+)/)[2]
      const xType = x.type
      const _isSeries = isSeries
      let columns = []
      let result = {}
      columns.push(xKey)

      if (x.name) {
        labelMap[xKey] = x.name
      }

      if (_isSeries) {
        const seriesName = _isSeries.replace(/(data\.)/, '')
        columns = columns.concat(ViewHelper.getSeriesDataColumns(_data, seriesName))
        _data = ViewHelper.seriesDataHandle(_data, xKey, seriesName)
      }

      y.map((y) => {
        const yKey = y.field.match(/(\w+\.)+(\w+)/)[2]
        columns.push(yKey)
        if (y.name) {
          labelMap[yKey] = y.name
        }
      })

      result = {
        name: name,
        rows: _data,
        columns: columns,
        labelMap
      }

      if (xType === 'time') {
        result.formatMap = {}
        result.formatMap[xKey] = 'TIME'
      }

      // console.info('viewConfig chartData', result)

      return result
    } catch (err) {
      console.error(err)
      return null
    }
  }
}

viewBiz.dataHelper = new DataHelper()
viewBiz.viewHelper = ViewHelper

export default viewBiz
